import { getEditLocation } from "../../../core/util/functions";

export const citiesLocation = "/listing/codebook/cities";
export const getCityEditLocation = (id?: string) => getEditLocation(citiesLocation, undefined, id);

export const editRouter = getCityEditLocation(":cityId?");
